// extracted by mini-css-extract-plugin
export default {"brandPromo":"kH-z","carousel":"lH-z"};